import React from 'react';
import { RELOAD_PAGE, SOMETHING_WRONG } from '../../constants/urls';
import { Container, HeaderText, IllustrationText, Refresh } from './styles';

interface ErrorBoundaryState {
  error: string | null;
}

export class ErrorBoundary extends React.Component<{}, ErrorBoundaryState> {
  constructor(props: {}) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      error: error.message,
    };
  }

  //   static componentDidCatch(error: Error, errorInfo) {
  //     Sentry.withScope(scope => {
  //       Object.keys(errorInfo).forEach(key => {
  //         scope.setExtra(key, errorInfo[key]);
  //       });

  //       Sentry.captureException(error);
  //     });
  //   }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    const reloadClick = () => {
      window.location.reload();
    };

    if (error) {
      return (
        <Container>
          <img src={SOMETHING_WRONG} alt="" width="145px" height="119.92px" />
          <HeaderText>Oops! Something went wrong</HeaderText>
          <IllustrationText>
            We are working on fixing the problem. Please refresh the page or try
            again later.
          </IllustrationText>
          <Refresh onClick={reloadClick}>
            <img src={RELOAD_PAGE} alt="" width="18px" height="18px" />
            <span>Refresh page</span>
          </Refresh>
        </Container>
      );
    }
    return children;
  }
}
